import React from 'react';
import PropTypes from 'prop-types';
import BaseWidget from 'nucleus-widgets/lib/BaseWidget';
import { resolve } from '@cvent/nucleus-dynamic-css';
import { Speaker as SpeakerType } from '../../../interfaces/eventPropTypes';
import { resolveTestId } from '@cvent/nucleus-test-automation';
import SpeakersStyles from '../SpeakersStyles.less';

export default class SpeakerProfileImage extends BaseWidget {
  static propTypes = {
    style: PropTypes.any.isRequired,
    classes: PropTypes.any.isRequired,
    speaker: SpeakerType,
    customClasses: PropTypes.any
  }

  render() {
    const { speaker: { profileImageUri, profileImageFileName = 'avatar.svg' }, customClasses }
      = this.props;
    const speakerClasses = { ...SpeakersStyles, ...customClasses };
    return (<div
      {...resolve({ ...this.props }, 'speakerProfileImageContainer')}
      {...resolveTestId(this.props, '-profileImage')}
    >
      { profileImageUri && <img
        src={profileImageUri} alt={profileImageFileName}
        {...resolve({ ...this.props, classes: speakerClasses },
          'speakerProfileImage', 'speakerImageContainer')}
      /> }
      { !profileImageUri && <div {...resolve({ ...this.props, classes: speakerClasses },
        'speakerProfileImage', 'speakerImageContainer', 'speakerBackgroundImageContainer')}
      /> }
    </div>);
  }
}
